import { Box, Flex, Text, Image, IconButton } from "@chakra-ui/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useState,useEffect } from "react";

import screen1 from "../../assets/table-1.png";
import screen2 from "../../assets/table-2.png";
import screen3 from "../../assets/table-3.png";

const screens = [screen1, screen2, screen3];

export default function PokerShowcase() {
  const [index, setIndex] = useState(0);
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  const prev = () => {
    setIndex((i) => (i === 0 ? screens.length - 1 : i - 1));
  };

  const next = () => {
    setIndex((i) => (i === screens.length - 1 ? 0 : i + 1));
  };

  const left = screens[(index - 1 + screens.length) % screens.length];
  const center = screens[index];
  const right = screens[(index + 1) % screens.length];

  return (
    <Box
      bg="radial-gradient(circle at top, #2a124f 0%, #0b0515 60%, #000 100%)"
      color="white"
      py={{ base: 12, md: 6 }}
      px={{ base: 4, md: 6 }}
    >
      {/* Title */}
      <Flex direction="column" align="center" textAlign="center" mb={{ base: 8, md: 12 }}>
                <Text fontSize={{ base: "70px", md: "126px" }} fontWeight="bold" bgGradient={"linear(to-r, #fff , #BDA8FB)" } bgClip={"text"}>
          Poker
        </Text>
        <Text maxW="700px" fontSize={{ base: "16px", md: "21px" }} opacity={0.8} mt={4} color={"#A78BFA"}>
          Join one of the world's most popular online free poker games with more tables, more tournaments, more jackpots, and more players to challenge than ever before! free-to-play poker app! Immerse yourself in the thrilling world of Texas & PLO poker.
        </Text>
      </Flex>

      {/* Showcase */}
      <Box
        maxW="1400px"
        mx="auto"
        
        bg="linear-gradient(180deg, rgba(140,94,255,0.18), rgba(140,94,255,0.05))"
        borderRadius="2xl"
        p={{ base: 4, md: 8 }}
        position="relative"
        boxShadow="0 0 80px rgba(140, 94, 255, 0.25)"
      >
        <Flex align="center" justify="center" gap={{ base: 2, md: 6 }}>
          {/* Left Arrow */}
          <IconButton
            icon={<FaChevronLeft />}
            onClick={prev}
            variant="ghost"
            color="purple.300"
            fontSize={{ base: "18px", md: "24px" }}
            _hover={{ bg: "whiteAlpha.200" }}
            aria-label="Previous"
          />

          {/* Images */}
          <Flex align="center" justify="center" gap={{ base: 2, md: 6 }}>
            {/* Left image - hidden on mobile */}
            <Image
              src={left}
              display={{ base: "none", md: "block" }}
              w={{ md: "180px", lg: "220px" }}
              opacity={0.5}
              transform="scale(0.9)"
              transition="all 0.3s ease"
              borderRadius="xl"
            />

            {/* Center image */}
            <Image
              src={center}
              w={{ base: "200px", sm: "240px", md: "280px", lg: "290px" }}
              borderRadius="xl"
              boxShadow="0 20px 60px rgba(0,0,0,0.6)"
              transition="all 0.3s ease"
            />

            {/* Right image - hidden on mobile */}
            <Image
              src={right}
              display={{ base: "none", md: "block" }}
              w={{ md: "180px", lg: "220px" }}
              opacity={0.5}
              transform="scale(0.9)"
              transition="all 0.3s ease"
              borderRadius="xl"
            />
          </Flex>

          {/* Right Arrow */}
          <IconButton
            icon={<FaChevronRight />}
            onClick={next}
            variant="ghost"
            color="purple.300"
            fontSize={{ base: "18px", md: "24px" }}
            _hover={{ bg: "whiteAlpha.200" }}
            aria-label="Next"
          />
        </Flex>
      </Box>
    </Box>
  );
}
